import React from 'react';
import { Users, CheckSquare, FileText, BarChart3, AlertCircle, Clock, TrendingUp, ShieldAlert, Database } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
export const AdminDashboard = () => {
  const {
    user
  } = useAuth();
  const stats = [{
    title: 'Active Users',
    value: '128',
    change: '+12%',
    trend: 'up',
    icon: <Users className="h-5 w-5 text-blue-600" data-id="element-205" />,
    color: 'bg-blue-50 border-blue-200'
  }, {
    title: 'Pending Tasks',
    value: '243',
    change: '+18%',
    trend: 'up',
    icon: <CheckSquare className="h-5 w-5 text-amber-600" data-id="element-206" />,
    color: 'bg-amber-50 border-amber-200'
  }, {
    title: 'Total Files',
    value: '1,845',
    change: '+7%',
    trend: 'up',
    icon: <FileText className="h-5 w-5 text-emerald-600" data-id="element-207" />,
    color: 'bg-emerald-50 border-emerald-200'
  }, {
    title: 'System Alerts',
    value: '2',
    change: '-50%',
    trend: 'down',
    icon: <AlertCircle className="h-5 w-5 text-rose-600" data-id="element-208" />,
    color: 'bg-rose-50 border-rose-200'
  }];
  const quickActions = [{
    title: 'Add New User',
    icon: <Users className="h-5 w-5" data-id="element-209" />
  }, {
    title: 'Security Audit',
    icon: <ShieldAlert className="h-5 w-5" data-id="element-210" />
  }, {
    title: 'System Backup',
    icon: <Database className="h-5 w-5" data-id="element-211" />
  }, {
    title: 'Generate Reports',
    icon: <BarChart3 className="h-5 w-5" data-id="element-212" />
  }];
  const recentActivities = [{
    user: 'Jane Smith',
    action: 'created a new task template',
    time: '15 minutes ago',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    user: 'Mark Wilson',
    action: 'updated department structure',
    time: '2 hours ago',
    avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    user: 'Sarah Johnson',
    action: 'assigned 15 new tasks',
    time: '5 hours ago',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }, {
    user: 'Robert Chen',
    action: 'modified security settings',
    time: 'Yesterday at 4:30 PM',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
  }];
  return <div className="py-6" data-id="element-213">
      <div className="flex items-center justify-between mb-6" data-id="element-214">
        <div data-id="element-215">
          <h1 className="text-2xl font-bold text-text-primary" data-id="element-216">
            Admin Dashboard
          </h1>
          <p className="text-text-secondary mt-1" data-id="element-217">Welcome back, {user?.name}</p>
        </div>
        <div className="flex items-center space-x-2 bg-surface-50 border border-border rounded-lg px-3 py-1.5" data-id="element-218">
          <Clock className="h-4 w-4 text-text-tertiary" data-id="element-219" />
          <span className="text-sm text-text-secondary" data-id="element-220">
            Last updated: Just now
          </span>
        </div>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-221">
        {stats.map((stat, index) => <div key={index} className={`${stat.color} border rounded-lg p-4 shadow-sm`} data-id="element-222">
            <div className="flex justify-between items-start" data-id="element-223">
              <div data-id="element-224">
                <p className="text-text-secondary text-sm font-medium" data-id="element-225">
                  {stat.title}
                </p>
                <p className="text-2xl font-bold text-text-primary mt-1" data-id="element-226">
                  {stat.value}
                </p>
              </div>
              <div className="p-2 rounded-full bg-white/80 shadow-sm" data-id="element-227">
                {stat.icon}
              </div>
            </div>
            <div className="flex items-center mt-3" data-id="element-228">
              <TrendingUp className={`h-4 w-4 ${stat.trend === 'up' ? 'text-emerald-500' : 'text-rose-500'}`} data-id="element-229" />
              <span className={`text-xs font-medium ml-1 ${stat.trend === 'up' ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-230">
                {stat.change} from last month
              </span>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-231">
        {/* Quick Actions */}
        <div className="bg-surface-50 border border-border rounded-lg shadow-sm p-5" data-id="element-232">
          <h2 className="text-lg font-semibold mb-4" data-id="element-233">Quick Actions</h2>
          <div className="grid grid-cols-2 gap-3" data-id="element-234">
            {quickActions.map((action, index) => <button key={index} className="flex flex-col items-center justify-center p-4 bg-white border border-border rounded-lg hover:bg-surface-100 transition-colors" data-id="element-235">
                <div className="p-2 rounded-full bg-brand-50 mb-2" data-id="element-236">
                  {action.icon}
                </div>
                <span className="text-sm font-medium text-text-primary" data-id="element-237">
                  {action.title}
                </span>
              </button>)}
          </div>
        </div>
        {/* Recent Activities */}
        <div className="bg-surface-50 border border-border rounded-lg shadow-sm p-5 lg:col-span-2" data-id="element-238">
          <h2 className="text-lg font-semibold mb-4" data-id="element-239">Recent Activities</h2>
          <div className="space-y-4" data-id="element-240">
            {recentActivities.map((activity, index) => <div key={index} className="flex items-start space-x-3 p-3 bg-white rounded-lg border border-border" data-id="element-241">
                <img src={activity.avatar} alt={activity.user} className="h-9 w-9 rounded-full object-cover border border-surface-200" data-id="element-242" />
                <div className="flex-1" data-id="element-243">
                  <p className="text-sm text-text-primary" data-id="element-244">
                    <span className="font-medium" data-id="element-245">{activity.user}</span>{' '}
                    {activity.action}
                  </p>
                  <div className="flex items-center mt-1" data-id="element-246">
                    <Clock className="h-3.5 w-3.5 text-text-tertiary mr-1" data-id="element-247" />
                    <p className="text-xs text-text-tertiary" data-id="element-248">
                      {activity.time}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};